import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 30 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.9998 36.0002H10.9998C7.25975 36.0002 6.07975 29.6402 5.57975 26.9202C5.53975 26.7202 5.41975 26.5202 5.23975 26.3602C2.07975 23.6602 0.159753 19.7202 -0.000246615 15.5802C-0.160247 11.6402 1.35975 7.6802 4.15975 4.7402C6.95975 1.7802 10.8198 0.0602 14.7598 0.000200041C18.7798 -0.0198 22.6398 1.4602 25.5198 4.3002C28.3998 7.1402 29.9998 10.9402 29.9998 15.0002C29.9998 19.3602 28.0998 23.5202 24.7598 26.3802C24.5798 26.5402 24.4598 26.7202 24.4198 26.9202C23.9598 29.4002 22.7398 36.0002 18.9998 36.0002ZM14.9998 2.0002C14.9998 2.0002 14.8598 2.0002 14.7798 2.0002C11.3798 2.0602 8.03975 3.5402 5.61975 6.1002C3.19975 8.6602 1.87975 12.0802 1.99975 15.5002C2.13975 19.1002 3.77975 22.5002 6.53975 24.8602C7.07975 25.3202 7.41975 25.9002 7.53975 26.5602C8.73975 33.0402 10.2198 34.0002 10.9998 34.0002H18.9998C19.7798 34.0002 21.2598 33.0402 22.4598 26.5602C22.5798 25.9002 22.9198 25.3202 23.4598 24.8602C26.3398 22.3802 27.9998 18.8002 27.9998 15.0002C27.9998 11.4802 26.6198 8.2002 24.1198 5.7402C21.6598 3.3202 18.4398 2.0002 14.9998 2.0002Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M19 40H11C10.44 40 10 39.56 10 39C10 38.44 10.44 38 11 38H19C19.56 38 20 38.44 20 39C20 39.56 19.56 40 19 40Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M19 44H11C10.44 44 10 43.56 10 43C10 42.44 10.44 42 11 42H19C19.56 42 20 42.44 20 43C20 43.56 19.56 44 19 44Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17 48H13C12.44 48 12 47.56 12 47C12 46.44 12.44 46 13 46H17C17.56 46 18 46.44 18 47C18 47.56 17.56 48 17 48Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }